module.exports = __webpack_public_path__ + "img/no-order.26f8a50a.png";